<template>
    <section class="type-section type-properties">
        <header>
            <h4 class="type-section-title">Properties</h4>
        </header>
        <table v-if="properties.length" class="type-property-table-list">
            <thead>
            <tr class="type-property-table-header">
                <th class="type-property-heading type-property-name">Name</th>
                <th class="type-property-heading type-property-types">Types</th>
                <th class="type-property-heading type-property-description">Description</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(property, index) in properties" :key="index" class="type-property">
                <td class="type-property-cell type-property-name">
                    <div class="type-property-name-inner">
                        <span class="property-name">{{ property.name }}</span>
                        <icon v-if="property.readOnly" name="lock" class="property-modifier"
                              title="This property is read-only."/>
                        <icon v-if="property.internal" name="warning" class="property-modifier"
                              title="This property is reserved for internal use and might be removed at any time."/>
                        <icon v-if="property.deprecated" name="thumb_down" class="property-modifier"
                              :title="property.deprecationNotice || 'This property is deprecated and will be removed soon.'"/>
                    </div>
                </td>
                <td class="type-property-cell type-property-types">
                    <template v-for="(propType, index) in property.types">
                        <type-link :type="propType" :key="index"/>
                        <span v-if="index < property.types.length - 1" class="property-type-link-separator">|</span>
                    </template>
                </td>
                <td class="type-property-cell type-property-description">
                    <markdown v-if="property.description.length"
                    >{{ property.description.replace(/\n/, ' ') }}
                    </markdown>
                    <span class="data-missing" v-else>No description available</span>
                </td>
            </tr>
            </tbody>
        </table>
        <span v-else class="data-missing">No properties available</span>
    </section>
</template>

<script>
  import Markdown from 'vue-markdown-v2';
  import Icon     from '../Layout/Icon';
  import TypeLink from './TypeLink';

  export default {
    name: 'TypeProperties',

    components: {
      TypeLink,
      Icon,
      Markdown,
    },

    props: {
      properties: {
        type:     Array,
        required: true,
      },
    },
  };
</script>

<style scoped>
    .type-property-table-list {
        width:           100%;
        border-collapse: collapse;
    }

    .type-property-heading,
    .type-property-cell {
        padding: 0.5rem;
    }

    .type-property-heading:first-child,
    .type-property-cell:first-child {
        padding-left: 0;
    }

    .type-property-heading {
        text-align:    left;
        border-top:    1px solid var(--color-gray-light);
        border-bottom: 1px solid var(--color-gray-light);
        color:         var(--color-gray-dark);
        font-weight:   600;
        text-transform: uppercase;
    }

    .type-property-cell {
        padding:        0.5rem;
        vertical-align: middle;
    }

    .type-property-cell >>> p {
        margin: 0;
    }

    .type-property-cell >>> p + p {
        margin-top: 0.25rem;
    }

    .type-property-cell.type-property-name .property-name {
        font-family: var(--font-family-monospace);
        font-size:   1.2rem;
        font-weight: 600;
    }

    .type-property-name-inner {
        display:     flex;
        align-items: center;
    }

    .type-property-cell.type-property-name .property-modifier {
        margin-left: 0.5rem;
        font-size:   1rem;
        cursor:      help;
        user-select: none;
        color:var(--color-secondary);
    }

    .data-missing {
        color: var(--color-gray-medium);
    }

    .property-type-link-separator {
        margin: 0 0.25rem;
    }
</style>
